var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('warning',{attrs:{"tree-title":"技术主题","body-title":"技术预警","category-field":_vm.categoryField}})}
var staticRenderFns = []

export { render, staticRenderFns }